module.exports = __webpack_public_path__ + "img/estimated-insurance-required-output.f74603be.svg";